import axios from "axios";

export default async function getLimitsRequest() {
    try {
        return await axios.post(`/rest/services/get-limits`);
    } catch (error) {
        throw error;
    }
}
